import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { buildHeaders, XmStore } from 'core/services';
import { ByodEligibility } from 'store/byod/models/eligibility';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { ModelBase } from 'store/model-base';
import { IXMOptions } from 'core/interfaces';
import { EligibilityByod, EligibilityByodStatus } from './models';

@Injectable()
export class ByodApi {
    public static byodEligibility(_xmStore: XmStore, http: HttpClient, params: ApiParams, _config: IXMOptions): Observable<ByodEligibility> {
        return http.get(`/devices/${params.imei}/byodeligibility`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY }),
            params: { intent: 'ACTIVATION', mode: 'TRIAL' }
        }).pipe(
            map((response: ApiResponse) => ByodEligibility.create<ByodEligibility>({ ...response, deviceImei: params.imei }))
        );
    }

    public static eligibilityByod(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<EligibilityByod> {
        return http.post('/devices/eligibility/byod', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: EligibilityByod) => EligibilityByod.create<EligibilityByod>(response))
        );
    }

    public static eligibilityByodStatus(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<EligibilityByodStatus> {
        return http.get(`/devices/eligibility/status?eligibilityRequestId=${params.requestId}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: EligibilityByodStatus) => EligibilityByodStatus.create<EligibilityByodStatus>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_BYOD_ELIGIBILITY] = ByodApi.byodEligibility;
ModelBase.persistMapping[StoreAction.POST_ELIGIBILITY_BYOD] = ByodApi.eligibilityByod;
ModelBase.fetchMapping[StoreAction.GET_ELIGIBILITY_BYOD_STATUS] = ByodApi.eligibilityByodStatus;

